import React, { useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import { BulletList } from "react-content-loader";
import { Trans } from "react-i18next";

const CheckoutForm = ({
    isSubmitting,
    setIsSubmitting,
    clientSecret,
    subscriptionId,
}) => {
    const stripe = useStripe();
    const elements = useElements();

    const [, setMessage] = useState(null);
    const [paymentIntent, setPaymentIntent] = useState(null);

    useEffect(() => {
        if (!stripe || !clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            setPaymentIntent(paymentIntent);
            switch (paymentIntent?.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage(
                        "Your payment was not successful, please try again."
                    );
                    break;
                default:
                    console.log("unable to get payment");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsSubmitting(true);

        const return_url = `${window.location.origin}/view/payments/confirm/${subscriptionId}`;
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occured.");
        }

        setIsSubmitting(false);
    };

    const isDisabled = () => {
        return isSubmitting || !stripe || !elements;
    };

    if (!paymentIntent) return <BulletList />;
    return (
        <form
            id="payment-form"
            onSubmit={handleSubmit}
            className="flex flex-col"
        >
            <PaymentElement id="stripe-payment-element" />
            <button
                disabled={isDisabled()}
                id="submit"
                className={`mt-5 w-15 rounded-xl bg-primary-color-blue ${
                    isDisabled() ? "disabled" : ""
                }`}
            >
                <span id="button-text">
                    {isSubmitting ? (
                        <>
                            <span className="animate-spin mr-3 inline-flex">
                                <i className="fas fa-sync"></i>
                            </span>
                            <Trans i18nKey="requesting">Requesting...</Trans>
                        </>
                    ) : (
                        "Pay now"
                    )}
                </span>
            </button>
        </form>
    );
};

export default CheckoutForm;
